import federcarniLogo from "@/assets/federcarni.webp";

export interface Certification {
  id: string;
  name: string;
  subLabel: string;
  logoUrl: string;
  description: string;
  externalLink?: string;
  priority: number;
  status?: "active" | "in-progress";
}

export const certifications: Certification[] = [
  {
    id: "slow-food",
    name: "Slow Food Arca del Gusto",
    subLabel: "Presidio L'Abatina",
    logoUrl: "/certifications/slow-food.webp",
    description:
      "L'Abatina, il nostro salume storico, è ufficialmente inserita nell'Arca del Gusto della Fondazione Slow Food. Un riconoscimento che tutela la biodiversità gastronomica italiana e premia chi, come noi, preserva ricette antiche a rischio di scomparire.",
    externalLink:
      "https://www.fondazioneslowfood.com/it/arca-del-gusto-slow-food/abatina/",
    priority: 1,
    status: "active",
  },
  {
    id: "fim",
    name: "F.I.M.",
    subLabel: "L'arte della Macelleria",
    logoUrl: "/certifications/fim.webp",
    description:
      "Siamo membri della Federazione Italiana Macellai, l'associazione nazionale che tutela la professionalità del macellaio artigiano. Un'adesione che ci impegna ogni giorno nella formazione continua, nella selezione rigorosa delle carni e nel rispetto degli standard etici della categoria.",
    priority: 2,
    status: "active",
  },
  {
    id: "federcarni",
    name: "Federcarni",
    subLabel: "Rete di macellai selezionati",
    logoUrl: federcarniLogo,
    description:
      "Facciamo parte di Federcarni, la Federazione Nazionale Macellai che tutela e rappresenta la professionalità della macelleria italiana.",
    priority: 6,
    status: "active",
  },
  {
    id: "visitmolise",
    name: "VisitMolise",
    subLabel: "Eccellenza del territorio",
    logoUrl: "/certifications/visitmolise.webp",
    description:
      "Siamo segnalati da VisitMolise tra le eccellenze enogastronomiche del territorio molisano. La nostra bottega è raccontata sui canali ufficiali del turismo regionale in italiano, inglese, tedesco e spagnolo, come ambasciatrice del gusto autentico del Molise.",
    externalLink:
      "https://www.visitmolise.eu/fr/servizio-turistico/-/d/dms/1542697/la-bottega-delle-carni-da-marco",
    priority: 4,
    status: "active",
  },
  {
    id: "premio-dino-villani",
    name: "Premio Dino Villani 2025",
    subLabel: "Accademia Italiana della Cucina",
    logoUrl: "/certifications/accademia-italiana-cucina.webp",
    description:
      "Nel 2025 L'Abatina è stata insignita del Premio Dino Villani, il prestigioso riconoscimento che l'Accademia Italiana della Cucina — istituzione culturale della Repubblica — assegna ogni anno al produttore che si distingue nella lavorazione artigianale di un prodotto alimentare di rilevante qualità organolettica, realizzato con ingredienti nazionali tracciabili e nel rispetto della tipicità e delle tradizioni del territorio.",
    externalLink: "https://www.accademiaitalianadellacucina.it/",
    priority: 3,
    status: "active",
  },
  {
    id: "deco-campobasso",
    name: "De.Co. Campobasso",
    subLabel: "Denominazione Comunale — L'Abatina",
    logoUrl: "/certifications/comune-campobasso.webp",
    description:
      "L'Abatina è ufficialmente iscritta nel registro De.Co. — Denominazione Comunale — del Comune di Campobasso, insieme alla Soppressata casereccia campobassana e all'acciaio traforato. Un marchio che tutela l'autenticità del prodotto, ne certifica il legame con il territorio e valorizza le tradizioni locali. La notizia è stata rilanciata a livello nazionale dall'agenzia ANSA.",
    priority: 5,
    status: "active",
  },
];